<template>
  <div class="ca-wire-transfer">
    <h2 class="ca-wire-transfer__title">支付订单</h2>

    <div v-loading="loading" class="ca-wire-transfer__card">
      <!-- 电汇收款账户：payAccount 接口，每次进页面实时取最新值（账户可能变更，不缓存） -->
      <div class="ca-wire-transfer__block-title">电汇信息</div>
      <div class="ca-wire-transfer__row">
        <span class="ca-wire-transfer__label">开户名称</span>
        <span class="ca-wire-transfer__value">{{ payAccount.accountName || '--' }}</span>
      </div>
      <div class="ca-wire-transfer__row">
        <span class="ca-wire-transfer__label">开户行</span>
        <span class="ca-wire-transfer__value">{{ payAccount.openingBank || '--' }}</span>
      </div>
      <div class="ca-wire-transfer__row">
        <span class="ca-wire-transfer__label">开户行账号</span>
        <span class="ca-wire-transfer__value">{{ payAccount.accountNo || '--' }}</span>
      </div>
      <div class="ca-wire-transfer__row">
        <span class="ca-wire-transfer__label">应付金额</span>
        <span class="ca-wire-transfer__value is-danger">
          {{ wireInfo.totalAmount ? '¥ ' + wireInfo.totalAmount : '--' }}
        </span>
      </div>

      <!-- 付款凭证：orderId 存在（订单已生成）才可上传确认；删除为红色文字（该页原型） -->
      <template v-if="orderId">
        <file-upload :file-id="voucherFileId" delete-as-text @fileIdCb="handleVoucherChange">
          <template #trigger>
            <button type="button" class="ca-wire-transfer__upload">上传</button>
          </template>
        </file-upload>
      </template>
    </div>

    <div class="ca-wire-transfer__footer">
      <el-button class="ca-wire-transfer__cancel" @click="handleCancel">
        取消
      </el-button>
      <el-button v-if="orderId" type="danger" :loading="submitting" @click="handleConfirm">
        确认
      </el-button>
    </div>
  </div>
</template>

<script>
import FileUpload from '../components/FileUpload.vue'
import { getPayAccount, getWireInfo, submitWireVoucher } from '@/api/ca'

export default {
  name: 'CaWireTransfer',
  components: { FileUpload },
  data() {
    return {
      // 电汇收款账户（payAccount 接口：accountName / openingBank / accountNo），
      // 每次进页面实时拉取不缓存（账户可能变更）
      payAccount: {},
      // 订单电汇信息（wireInfo 接口，传 orderId）：仅取已上传凭证 wireVoucherFileId 回填
      // （应付金额 totalAmount 有则展示，无则 --）
      wireInfo: {},
      voucherFileId: '', // 已上传的付款凭证 fileId；为空时「确认」会被拦截
      loading: false, // 电汇信息加载中
      submitting: false, // 凭证提交中 → 确认按钮 loading 防重复
    }
  },
  computed: {
    // 订单 id 从 query 取；wireInfo 接口必填 orderId，缺省时只拉收款账户、不回填凭证
    orderId() {
      return this.$route.query.orderId
    },
  },
  created() {
    this.loadWireInfo()
  },
  methods: {
    // 电汇页数据 = 收款账户（payAccount，无入参）+ 订单已传凭证（wireInfo，传 orderId，
    // 后端确认该接口仅返回凭证文件，账户信息不在其中）
    loadWireInfo() {
      this.loading = true
      getPayAccount()
        .then((accRes) => {
          this.payAccount = accRes.data || {}
          if (!this.orderId) return null
          return getWireInfo({ orderId: this.orderId }).then((wireRes) => {
            const wire = wireRes.data || {}
            this.wireInfo = wire
            this.voucherFileId = wire.wireVoucherFileId || ''
          })
        })
        .finally(() => {
          this.loading = false
        })
    },
    handleVoucherChange(res) {
      this.voucherFileId = res.url || ''
    },
    handleCancel() {
      this.$router.back() // 不改变订单状态
    },
    handleConfirm() {
      if (!this.voucherFileId) {
        this.$message.warning('请上传付款凭证')
        return
      }
      this.submitting = true
      // 上传凭证后订单进入「待电汇确认」（文档 §4.7），等后台核实到账后流转审核中
      submitWireVoucher({ orderId: this.orderId, wireVoucherFileId: this.voucherFileId })
        .then(() => {
          this.$router.push({ name: 'ca-orders' })
        })
        .finally(() => {
          this.submitting = false
        })
    },
  },
}
</script>
